(function ($) {$(function(){
    const $slider = $('.page-template-Home .swiper');
    
    if ($slider.length) {
        const swiper = new Swiper('.swiper', {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            on: {
                slideChangeTransitionStart: function () {
                    const nextVideo = $('div.swiper-slide.swiper-slide-next').find('video')
                    nextVideo.each(function (video) {
                        const $this = $(this);
                        $this.get(0).play()
                    })
                },
                slideChangeTransitionEnd: function(a){
                    const activeVideo = $('div.swiper-slide.swiper-slide-active').find('video')
                    const $videos = $('div.swiper-slide video').not(activeVideo);
                    $videos.each(function (video) {
                        const $this = $(this);
                        $this.get(0).pause()
                    })
                    activeVideo.each(function (video) {
                        const $this = $(this);
                        $this.get(0).play()
                    })

                    const w = activeVideo.width(true);
                    const h = activeVideo.height(true);
                    const containerW = activeVideo.parent().width();
                    const containerH = activeVideo.parent().height();
                    if (containerW > w) {
                        activeVideo.parent().addClass('landscape');
                    } 
                    if (containerH > h) {
                        activeVideo.parent().removeClass('landscape');
                    }
                },
                afterInit: function(a){
                    const activeVideo = $('div.swiper-slide.swiper-slide-active').find('video')
                    const w = activeVideo.width();
                    const h = activeVideo.height();
                    const containerW = activeVideo.parent().width();
                    const containerH = activeVideo.parent().height();
                    if (containerW > w) {
                        activeVideo.parent().addClass('landscape');
                    } 
                    if (containerH > h) {
                        activeVideo.parent().removeClass('landscape');
                    }
                },
            }
        });
    }
    setInterval(function(){
        const activeVideo = $('div.swiper-slide.swiper-slide-active').find('video')
        const w = activeVideo.width();
        const h = activeVideo.height();
        const containerW = activeVideo.parent().width();
        const containerH = activeVideo.parent().height();
        if (containerW > w) {
            activeVideo.parent().addClass('landscape');
        } 
        if (containerH > h) {
            activeVideo.parent().removeClass('landscape');
        }
    }, 300);
});}(_jQ3));
